/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Container, Checkbox, Segment, Grid,
  Header, Divider, Button, Dimmer, Loader,
  Popup, Icon, Form, Input
} from "semantic-ui-react";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();
const MAX_PING_LIMIT = 10000;
const MAX_PACKET_LOSS_RATE_LIMIT = 100;

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,
      isDuplicateIpProblemChecked: false,
      isExceededPingProblemChecked: false,
      isDHCPProblemChecked: false,
      isLostPingsProblemChecked: false,
      isInactivePortsProblemChecked: false,
      isAutonegotiationProblemChecked: false,
      isFullDuplexProblemChecked: false,
      isSlowSpeedProblemChecked: false,
      isLocalHardwareFaultProblemChecked: false,
      isACDProblemChecked: false,
      isMediaCountersProblemChecked: false,
      isInterfaceCountersProblemChecked: false,
      isFaultProblemChecked: false,
      isLostIpProblemChecked: false,
      isAlterPingDimmerActive: false,
      pingLimit: "",
      isAlterPingLossLimitDimmerActive: false,
      pingLossLimit: "",
    };
  }

  retrieveData = () => {
    this.retrieveTsExpertConfigData();
    this.retrievePingLimitConfigData();
    this.retrievePingLossLimitConfigData();
  }

  retrieveTsExpertConfigData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isDuplicateIpProblemChecked: data.isDuplicateIpProblemChecked,
        isExceededPingProblemChecked: data.isExceededPingProblemChecked,
        isDHCPProblemChecked: data.isDHCPProblemChecked,
        isLostPingsProblemChecked: data.isLostPingsProblemChecked,
        isInactivePortsProblemChecked: data.isInactivePortsProblemChecked,
        isAutonegotiationProblemChecked: data.isAutonegotiationProblemChecked,
        isFullDuplexProblemChecked: data.isFullDuplexProblemChecked,
        isSlowSpeedProblemChecked: data.isSlowSpeedProblemChecked,
        isLocalHardwareFaultProblemChecked: data.isLocalHardwareFaultProblemChecked,
        isACDProblemChecked: data.isACDProblemChecked,
        isMediaCountersProblemChecked: data.isMediaCountersProblemChecked,
        isInterfaceCountersProblemChecked: data.isInterfaceCountersProblemChecked,
        isFaultProblemChecked: data.isFaultProblemChecked,
        isLostIpProblemChecked: data.isLostIpProblemChecked,
      }));
  }

  retrievePingLimitConfigData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "pingLimitConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        pingLimit: data.pingLimit
      }));
  }

  retrievePingLossLimitConfigData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "pingLossLimitConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        pingLossLimit: data.pingLossLimit
      }));
  }

  // ------ Toggle Checkboxes ---------
  toggleIsDuplicateIpProblemCheckbox = () => {
    this.setState({ isDuplicateIpProblemChecked: !this.state.isDuplicateIpProblemChecked });
  }

  toggleIsExceededPingProblemCheckbox = () => {
    this.setState({ isExceededPingProblemChecked: !this.state.isExceededPingProblemChecked });
  }

  toggleIsDHCPProblemCheckbox = () => {
    this.setState({ isDHCPProblemChecked: !this.state.isDHCPProblemChecked });
  }

  toggleIsLostPingsProblemCheckbox = () => {
    this.setState({ isLostPingsProblemChecked: !this.state.isLostPingsProblemChecked });
  }

  toggleIsInactivePortsProblemCheckbox = () => {
    this.setState({ isInactivePortsProblemChecked: !this.state.isInactivePortsProblemChecked });
  }

  toggleIsAutonegotiationProblemCheckbox = () => {
    this.setState({ isAutonegotiationProblemChecked: !this.state.isAutonegotiationProblemChecked });
  }

  toggleIsFullDuplexProblemCheckbox = () => {
    this.setState({ isFullDuplexProblemChecked: !this.state.isFullDuplexProblemChecked });
  }

  toggleIsSlowSpeedProblemCheckbox = () => {
    this.setState({ isSlowSpeedProblemChecked: !this.state.isSlowSpeedProblemChecked });
  }

  toggleIsLocalHardwareFaultProblemCheckbox = () => {
    this.setState({ isLocalHardwareFaultProblemChecked: !this.state.isLocalHardwareFaultProblemChecked });
  }

  toggleIsACDProblemCheckbox = () => {
    this.setState({ isACDProblemChecked: !this.state.isACDProblemChecked });
  }

  toggleIsMediaCountersProblemCheckbox = () => {
    this.setState({ isMediaCountersProblemChecked: !this.state.isMediaCountersProblemChecked });
  }

  toggleIsInterfaceCountersProblemCheckbox = () => {
    this.setState({ isInterfaceCountersProblemChecked: !this.state.isInterfaceCountersProblemChecked });
  }

  toggleIsFaultProblemCheckbox = () => {
    this.setState({ isFaultProblemChecked: !this.state.isFaultProblemChecked });
  }

  toggleIsLostIpProblemCheckbox = () => {
    this.setState({ isLostIpProblemChecked: !this.state.isLostIpProblemChecked });
  }

  // Save the configuration
  saveTsExpertConfiguration = () => {
    this.showSendingConfigDimmer();

    let data = {
      isDuplicateIpProblemChecked: this.state.isDuplicateIpProblemChecked,
      isExceededPingProblemChecked: this.state.isExceededPingProblemChecked,
      isDHCPProblemChecked: this.state.isDHCPProblemChecked,
      isLostPingsProblemChecked: this.state.isLostPingsProblemChecked,
      isInactivePortsProblemChecked: this.state.isInactivePortsProblemChecked,
      isAutonegotiationProblemChecked: this.state.isAutonegotiationProblemChecked,
      isFullDuplexProblemChecked: this.state.isFullDuplexProblemChecked,
      isSlowSpeedProblemChecked: this.state.isSlowSpeedProblemChecked,
      isLocalHardwareFaultProblemChecked: this.state.isLocalHardwareFaultProblemChecked,
      isACDProblemChecked: this.state.isACDProblemChecked,
      isMediaCountersProblemChecked: this.state.isMediaCountersProblemChecked,
      isInterfaceCountersProblemChecked: this.state.isInterfaceCountersProblemChecked,
      isFaultProblemChecked: this.state.isFaultProblemChecked,
      isLostIpProblemChecked: this.state.isLostIpProblemChecked,
    };

    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
        this.retrieveTsExpertConfigData();
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideSendingConfigDimmer);
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });
  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  showAlterPingDimmer = () => this.setState({ isAlterPingDimmerActive: true });
  hideAlterPingDimmer = () => this.setState({ isAlterPingDimmerActive: false });

  showAlterPingLossLimit = () => this.setState({ isAlterPingLossLimitDimmerActive: true });
  hideAlterPingLossLimit = () => this.setState({ isAlterPingLossLimitDimmerActive: false });

  alterPingLimit = () => {
    let typedNumber = Number(this.state.pingLimit);

    // Only let the user save ping values between the min and max packet values
    if (typedNumber >= 0 && typedNumber <= MAX_PING_LIMIT) {

      this.showAlterPingDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "alterPingLimit_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ pingLimit: typedNumber })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.ALTER_PING_LIMIT_SUCCESS);
          this.retrievePingLimitConfigData();
        })
        .catch((error) => {
          alert(Strings.ALTER_PING_LIMIT_ERROR + "\n" + Strings.REASON_DP + error.message);
        })
        .finally(this.hideAlterPingDimmer);

    }
    else {
      alert(Strings.PING_LIMIT_OUT_OF_BOUNDS + "\n" + Strings.CURRENT_VALUE_DP + this.state.pingLimit + Strings.MILLISECONDS_SUFFIX);
    }
  }

  alterPingLossLimit = () => {
    let typedNumber = Number(this.state.pingLossLimit);

    // Only let the user limits between 0 and 100%
    if (typedNumber >= 0 && typedNumber <= MAX_PACKET_LOSS_RATE_LIMIT) {

      this.showAlterPingLossLimit();

      fetch(Constants.REQUEST_IP_ADDRESS + "alterPingLossLimitConfig_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ pingLossLimit: typedNumber })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.ALTER_PACKET_LOSS_RATE_LIMIT_SUCCESS);
          this.retrievePingLossLimitConfigData();
        })
        .catch((error) => {
          alert(Strings.ALTER_PACKET_LOSS_RATE_LIMIT_ERROR + "\n" + Strings.REASON_DP + error.message);
        })
        .finally(this.hideAlterPingLossLimit);

    }
    else {
      alert(Strings.PACKET_LOSS_RATE_LIMIT_OUT_OF_BOUNDS + "\n" + Strings.CURRENT_VALUE_DP + this.state.pingLossLimit + "%");
    }
  }

  handlePingLimitChange = (e, { value }) => {
    this.setState({ pingLimit: value });
  }

  handlePingLossLimitChange = (e, { value }) => {
    this.setState({ pingLossLimit: value });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    return (
      <Container>
        <Grid columns={2} doubling>
          <Grid.Column width={10}>
            <Segment>
              <Header as='h2' textAlign="center" color="teal">
                {Strings.TS_EXPERT_CONFIGURATION}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>

                <List divided verticalAlign='middle'>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.DUPLICATE_IP_STRING}</List.Header>
                          {Strings.CONFIG_DUPLICATE_IP_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsDuplicateIpProblemCheckbox}
                            checked={this.state.isDuplicateIpProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_EXCEEDED_PING_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_EXCEEDED_PING_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsExceededPingProblemCheckbox}
                            checked={this.state.isExceededPingProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_DHCP_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_DHCP_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsDHCPProblemCheckbox}
                            checked={this.state.isDHCPProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_LOST_PINGS_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_LOST_PINGS_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsLostPingsProblemCheckbox}
                            checked={this.state.isLostPingsProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_INACTIVE_PORT_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_INACTIVE_PORT_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsInactivePortsProblemCheckbox}
                            checked={this.state.isInactivePortsProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_AUTO_NEGOTIATION_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_AUTO_NEGOTIATION_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsAutonegotiationProblemCheckbox}
                            checked={this.state.isAutonegotiationProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_DUPLEX_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_DUPLEX_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsFullDuplexProblemCheckbox}
                            checked={this.state.isFullDuplexProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_SLOW_SPEED_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_SLOW_SPEED_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsSlowSpeedProblemCheckbox}
                            checked={this.state.isSlowSpeedProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_LOCAL_HARDWARE_FAULT_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_LOCAL_HARDWARE_FAULT_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsLocalHardwareFaultProblemCheckbox}
                            checked={this.state.isLocalHardwareFaultProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_ACD_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_ACD_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsACDProblemCheckbox}
                            checked={this.state.isACDProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_MEDIA_COUNTERS_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_MEDIA_COUNTERS_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsMediaCountersProblemCheckbox}
                            checked={this.state.isMediaCountersProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_INTERFACE_COUNTERS_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_INTERFACE_COUNTERS_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsInterfaceCountersProblemCheckbox}
                            checked={this.state.isInterfaceCountersProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_FAULTS_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_FAULTS_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsFaultProblemCheckbox}
                            checked={this.state.isFaultProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_LOST_IP_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_LOST_IP_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsLostIpProblemCheckbox}
                            checked={this.state.isLostIpProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                </List>

              </Segment>

              <Button
                fluid
                color="teal"
                content={Strings.SAVE}
                onClick={this.saveTsExpertConfiguration} />

              <Dimmer active={this.state.isSendingConfigDimmerActive} >
                <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
              </Dimmer>

            </Segment>
          </Grid.Column>

          <Grid.Column width={6}>
            <Segment>
              <Divider horizontal>
                {Strings.PING_LIMIT}
                <Popup position='bottom center' hoverable pinned wide="very"
                  trigger={
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  }>
                  <Popup.Content>
                    <p> {Strings.PING_LIMIT_POPUP_1} </p>
                    <p> {Strings.PING_LIMIT_POPUP_2} </p>
                    <p> <b>{Strings.OBS} 1:</b> {Strings.PING_LIMIT_POPUP_3} </p>
                    <p> <b>{Strings.OBS} 2:</b>  {Strings.PING_LIMIT_POPUP_4} </p>
                    <p> <b>{Strings.OBS} 3:</b>  {Strings.PING_LIMIT_POPUP_5} </p>
                  </Popup.Content>
                </Popup>
              </Divider>

              <Form style={formStyle} onSubmit={this.alterPingLimit}>
                <Form.Field inline>
                  <Input
                    type="number"
                    placeholder={Strings.PING_LIMIT_PLACEHOLDER}
                    label={{ basic: true, content: Strings.MILLISECONDS_UNIT }}
                    labelPosition='right'
                    value={this.state.pingLimit}
                    onChange={this.handlePingLimitChange} />
                </Form.Field>
                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={this.state.isAlterPingDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment>
              <Divider horizontal>
                {Strings.PACKET_LOSS_RATE}
                <Popup position='top center' hoverable pinned wide
                  trigger={
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  }>
                  <Popup.Content>
                    <p> {Strings.PACKET_LOSS_POPUP} </p>
                  </Popup.Content>
                </Popup>
              </Divider>

              <Form style={formStyle} onSubmit={this.alterPingLossLimit}>
                <Form.Field inline>
                  <Input
                    type="number"
                    placeholder={Strings.PACKET_LOSS_RATE_PLACEHOLDER}
                    label={{ basic: true, content: Strings.PERCENTAGE_UNIT }}
                    labelPosition='right'
                    value={this.state.pingLossLimit}
                    onChange={this.handlePingLossLimitChange} />
                </Form.Field>
                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={this.state.isAlterPingLossLimitDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default TsExpertConfig;
